//Home User
$(document).on('click','.carnet-avatar',function(){
    $("#camara").click();
});
$(document).on('change','#camara',function(){
    $("#formCambioAvatar").submit();
});

$('.home-container').ready(function(){
    infogeneral($("#ano").val());
});
$(document).on('change','#ano',function(){
    infogeneral($(this).val());
    $('.download-1trimestre').attr('href','/home/descargatrimestre/1/'+$(this).val());
    $('.download-2trimestre').attr('href','/home/descargatrimestre/2/'+$(this).val());
    $('.download-3trimestre').attr('href','/home/descargatrimestre/3/'+$(this).val());
    $('.download-4trimestre').attr('href','/home/descargatrimestre/4/'+$(this).val());
});

function infogeneral(ano){
    console.log(ano);
    $.ajax({
        url: '/home/infogeneral/'+ano,
        type: 'GET',
        success: function(response){
            
            $("#cuantos-clientes").html(response.cuantos_clientes);
            $("#total-ingresos").html(response.total_facturado+" €");
            $.each(response.trimestres_facturado,function(index,value){
                $("#"+(index)+"-ingresos").html(value+" €");
            });
            $("#total-iva-facturado").html(response.total_iva_facturado+" €");
            $.each(response.trimestres_iva_facturado,function(index,value){
                $("#"+(index)+"-iva-facturado").html(value+" €");
            });
            $("#total-irpf-retenido").html(response.total_irpf_retenido+" €");
            $.each(response.trimestres_irpf_retenido,function(index,value){
                $("#"+(index)+"-irpf-retenido").html(value+" €");
            });
            $("#total-gastos").html(response.total_gastado+" €");
            $.each(response.trimestres_gastado,function(index,value){
                $("#"+(index)+"-gastos").html(value+" €");
            });
            $("#total-iva-devengado").html(response.total_iva_devengado+" €");
            $.each(response.trimestres_iva_devengado,function(index,value){
                $("#"+(index)+"-iva-devengado").html(value+" €");
            });
            $("#total-irpf-repercutido").html(response.total_irpf_repercutido+" €");
            $.each(response.trimestres_irpf_repercutido,function(index,value){
                $("#"+(index)+"-irpf-repercutido").html(value+" €");
            });
            $("#total-beneficio-neto").html(response.total_neto+" €");
            $.each(response.trimestres_neto,function(index,value){
                $("#"+(index)+"-beneficio-neto").html(value+" €");
            });
            $("#total-declaracion-iva").html(response.total_declaracion_iva+" €");
            $.each(response.trimestres_declaracion_iva,function(index,value){
                $("#"+(index)+"-declaracion-iva").html(value+" €");
            });
            $("#total-declaracion-irpf").html(response.total_declaracion_irpf+" €");
            $.each(response.trimestres_declaracion_irpf,function(index,value){
                $("#"+(index)+"-declaracion-irpf").html(value+" €");
            });

            // Iluminar trimestre actual, marcar pasados y desactivar futuros
            $("[class^='row-trimestre-']").css({
                'background-color': '',
                'opacity': '',
                'color': '',
                'border-left': '',
                'font-weight': ''
            });
            $(".row-trimestre-1, .row-trimestre-2, .row-trimestre-3, .row-trimestre-4").find("a.btn").css({
                'pointer-events': '',
                'opacity': ''
            });
            $(".td-label-trimestre").find(".badge, i").remove();

            let currentYear = new Date().getFullYear();
            let selectedYear = parseInt(ano);
            let activeQuarter = response.proyeccion ? parseInt(response.proyeccion.trimestre_actual) : 1;

            for (let q = 1; q <= 4; q++) {
                let rows = $(".row-trimestre-" + q);
                let labelTd = rows.find(".td-label-trimestre");
                let downloadBtn = rows.find("a.btn");

                if (selectedYear < currentYear) {
                    // Año pasado: todos los trimestres están pasados
                    rows.css({
                        'background-color': 'rgba(25, 135, 84, 0.03)',
                        'color': '#198754'
                    });
                    labelTd.append(' <i class="bi bi-check-circle-fill text-success ms-1" style="font-size: 0.75rem;" title="Trimestre cerrado"></i>');
                } else if (selectedYear > currentYear) {
                    // Año futuro: todos los trimestres desactivados
                    rows.css({
                        'opacity': '0.5',
                        'color': '#6c757d'
                    });
                    downloadBtn.css({
                        'pointer-events': 'none',
                        'opacity': '0.5'
                    });
                    labelTd.append(' <i class="bi bi-lock-fill text-muted ms-1" style="font-size: 0.75rem;" title="Trimestre futuro"></i>');
                } else {
                    // Año actual
                    if (q < activeQuarter) {
                        // Trimestres pasados
                        rows.css({
                            'background-color': 'rgba(25, 135, 84, 0.03)',
                            'color': '#198754'
                        });
                        labelTd.append(' <i class="bi bi-check-circle-fill text-success ms-1" style="font-size: 0.75rem;" title="Trimestre cerrado"></i>');
                    } else if (q === activeQuarter) {
                        // Trimestre en curso (Iluminado)
                        rows.css({
                            'background-color': 'rgba(13, 110, 253, 0.08)',
                            'font-weight': 'bold',
                            'border-left': '4px solid #0d6efd',
                            'color': '#0d6efd'
                        });
                        labelTd.append(' <span class="badge bg-primary ms-1" style="font-size: 0.65rem;">En curso</span>');
                    } else {
                        // Trimestres futuros
                        rows.css({
                            'opacity': '0.5',
                            'color': '#6c757d'
                        });
                        downloadBtn.css({
                            'pointer-events': 'none',
                            'opacity': '0.5'
                        });
                        labelTd.append(' <i class="bi bi-lock-fill text-muted ms-1" style="font-size: 0.75rem;" title="Trimestre futuro"></i>');
                    }
                }
            }

            // Nuevos datos de proyeccion
            if(response.proyeccion){
                $("#num-trimestre").html(response.proyeccion.trimestre_actual);
                $("#dias-restantes").html(response.proyeccion.dias);
                $("#progreso-trimestre").css('width', response.proyeccion.progreso + '%');
                $("#proyeccion-iva").html(response.proyeccion.iva + " €");
                $("#proyeccion-irpf").html(response.proyeccion.irpf + " €");
                $("#proyeccion-beneficio").html(response.proyeccion.beneficio + " €");
                
                if(parseFloat(response.proyeccion.beneficio.replace(',','')) < 0) {
                    $("#proyeccion-beneficio").removeClass('text-success').addClass('text-danger');
                } else {
                    $("#proyeccion-beneficio").removeClass('text-danger').addClass('text-success');
                }
            }

            // Nuevos datos de autónomo y ganancias limpias
            $("#total-limpio-anual").html(response.total_limpio_anual + " €");
            
            if(response.proyeccion_recurrente) {
                $("#mrr-proyectado").html(response.proyeccion_recurrente.mrr + " €");
                $("#arr-proyectado").html(response.proyeccion_recurrente.arr + " €");
                $("#fijos-mensuales").html("-" + response.proyeccion_recurrente.fijos + " €");
                $("#neto-recurrente-estimado").html(response.proyeccion_recurrente.estimado_limpio_mensual + " €");
            }
            
            if(response.recurrencia) {
                $("#val-mensual").html(response.recurrencia.mensual + " €");
                $("#val-anual").html(response.recurrencia.anual + " €");
                $("#val-puntual").html(response.recurrencia.puntual + " €");
                
                $("#pct-mensual").html(response.recurrencia.porcentaje_mensual);
                $("#pct-anual").html(response.recurrencia.porcentaje_anual);
                $("#pct-puntual").html(response.recurrencia.porcentaje_puntual);
                
                $("#pb-mensual").css('width', response.recurrencia.porcentaje_mensual + '%');
                $("#pb-anual").css('width', response.recurrencia.porcentaje_anual + '%');
                $("#pb-puntual").css('width', response.recurrencia.porcentaje_puntual + '%');
            }
            
            if(response.meses_desglose) {
                let htmlTabla = '';
                let currentMonth = new Date().getMonth() + 1;
                let currentYear = new Date().getFullYear();
                let selectedYear = parseInt(ano);

                response.meses_desglose.forEach(function(mes) {
                    let badgeClase = mes.es_positivo ? 'text-success fw-bold' : 'text-danger fw-bold';
                    let rowStyle = '';
                    let labelExtra = '';

                    if (selectedYear < currentYear) {
                        // Mes pasado
                        rowStyle = 'background-color: rgba(25, 135, 84, 0.03); color: #198754;';
                        labelExtra = ' <i class="bi bi-check-circle-fill text-success ms-1" style="font-size: 0.75rem;" title="Mes cerrado"></i>';
                    } else if (selectedYear > currentYear) {
                        // Mes futuro
                        rowStyle = 'opacity: 0.5; color: #6c757d;';
                        labelExtra = ' <i class="bi bi-lock-fill text-muted ms-1" style="font-size: 0.75rem;" title="Mes futuro"></i>';
                    } else {
                        // Año actual
                        if (mes.numero < currentMonth) {
                            // Mes pasado
                            rowStyle = 'background-color: rgba(25, 135, 84, 0.03); color: #198754;';
                            labelExtra = ' <i class="bi bi-check-circle-fill text-success ms-1" style="font-size: 0.75rem;" title="Mes cerrado"></i>';
                        } else if (mes.numero === currentMonth) {
                            // Mes en curso
                            rowStyle = 'background-color: rgba(13, 110, 253, 0.08); font-weight: bold; border-left: 4px solid #0d6efd; color: #0d6efd;';
                            labelExtra = ' <span class="badge bg-primary ms-1" style="font-size: 0.65rem;">En curso</span>';
                        } else {
                            // Mes futuro
                            rowStyle = 'opacity: 0.5; color: #6c757d;';
                            labelExtra = ' <i class="bi bi-lock-fill text-muted ms-1" style="font-size: 0.75rem;" title="Mes futuro"></i>';
                        }
                    }

                    htmlTabla += `
                        <tr style="${rowStyle}">
                            <td class="fw-bold text-start ps-4">${mes.nombre}${labelExtra}</td>
                            <td>${mes.ingresos} €</td>
                            <td>${mes.gastos} €</td>
                            <td class="text-danger">-${mes.fijos} €</td>
                            <td>${mes.irpf_total} €</td>
                            <td class="${badgeClase}">${mes.neto_limpio} €</td>
                        </tr>
                    `;
                });
                $("#tabla-desglose-mensual").html(htmlTabla);
            }
        }
    });
}